<template>
  <main class="h-100 container-fluid p-0 bg-primary">
    <border-layout>
      <scrollable>
        <div class="h-50 border-bottom border-white bg-cover bg-home">
          <div class="text-white pt-3 text-shadow-primary">
            <h1 class="text-center">
              Scegli il servizio che ti interessa
            </h1>
            <h3 class="text-center">
              al resto pensiamo noi
            </h3>
          </div>
        </div>

        <b-card-group deck class="mt-3 m-0 p-3">
          <b-card
            v-if="showCreditAssignments"
            overlay
            class="rounded-lg text-shadow-primary box-shadow-dark cursor-pointer hover-opaque bg-credit-assignment-card col-md-3 px-0"
            text-variant="white"
            img-src="/app/img/credit_assignment.jpg"
            title="Cessione crediti"
            @click.prevent.stop="
              $router.push({
                name: 'CreditAssignmentExternalRequest',
                query
              })
            "
          >
          </b-card>

          <b-card
            v-if="showMicroCredit"
            overlay
            class="rounded-lg text-shadow-primary box-shadow-dark cursor-pointer hover-opaque bg-micro-credit-card col-md-3 px-0"
            text-variant="white"
            img-src="/app/img/micro_credit.jpg"
            title="Micro credito"
            @click.prevent.stop="
              $router.push({
                name: 'MicroCreditExternalRequest',
                query
              })
            "
          >
          </b-card>

          <b-card
            v-if="showLoans"
            overlay
            class="rounded-lg text-shadow-primary box-shadow-dark coming-soon col-md-3 px-0"
            text-variant="white"
            img-src="/app/img/loan.jpg"
            title="Finanziamenti"
          >
          </b-card>

          <b-card
            v-if="showRealEstate"
            overlay
            class="rounded-lg text-shadow-primary box-shadow-dark coming-soon col-md-3 px-0"
            text-variant="white"
            img-src="/app/img/real_estate.jpg"
            title="Servizi immobiliari"
          >
          </b-card>
        </b-card-group>
      </scrollable>
    </border-layout>
  </main>
</template>
<script>
export default {
  props: {
    showCreditAssignments: {
      type: Boolean,
      default: true
    },

    showMicroCredit: {
      type: Boolean,
      default: true
    },

    showLoans: {
      type: Boolean,
      default: true
    },

    showRealEstate: {
      type: Boolean,
      default: true
    },

    defaultNetwork: {
      type: String,
      default: undefined
    }
  },

  computed: {
    missingParameters() {
      return !this.defaultNetwork && !this.$route.query.n;
    },

    query() {
      return {
        n: this.defaultNetwork,
        ...this.$route.query
      };
    }
  }

  /*
  watch: {
    '$route'(newValue) {
      this.missingParameters = !newValue.query.n;
    },
  },
  */
};
</script>
